"use client";

import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

export function Logo() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link
      href="/"
      aria-label="StickerGiant home"
      className="group block hover:opacity-100!"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="transition-all duration-500 ease-out"
        style={{
          transform: isHovered ? "rotate(-3deg) translate(-4px, -6px)" : "rotate(0deg) translate(0, 0)",
          transformOrigin: "bottom right",
          filter: isHovered ? "drop-shadow(3px 6px 5px rgba(0,0,0,0.20))" : "drop-shadow(1px 2px 3px rgba(0,0,0,0.10))",
        }}
      >
        <div className="relative overflow-hidden">
          {/* No `priority`: its preload was never consumed (Chrome warned on every page). */}
          <Image src="/images/sg-logo-with-shadow.svg" alt="StickerGiant" width={80} height={53} />
          <div
            aria-hidden="true"
            className="pointer-events-none absolute top-0 left-0 h-full w-1/2 opacity-0 bg-linear-to-r from-transparent from-20% via-white/20 via-50% to-transparent to-80% group-hover:animate-[logo-shimmer_1.6s_ease-in-out]"
            style={{
              maskImage: "url('/images/sg-logo-with-shadow.svg')",
              maskSize: "contain",
              maskRepeat: "no-repeat",
              maskPosition: "center",
            }}
          />
        </div>
      </div>
    </Link>
  );
}
